// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","container":"_3d-6XN9-nZ0poNGz9oF97S","descriptionWarning":"syU8paDxJDztG8MDsn6CH","inputContainer":"_1hXWNUYazc-45xkmSiNFVx"};